import { ForgotPasswordContent } from "../../sections/forgotPassword/ForgotPasswordContent"

export default function ForgotPassword() {
  return <ForgotPasswordContent />
}
